module.exports = __webpack_public_path__ + "static/call-to-action-aa94e697099c9fcd68638f9518dbb2fb.mp4";